import { render, staticRenderFns } from "./SingleJobView.vue?vue&type=template&id=54f3ba1c&scoped=true&"
import script from "./SingleJobView.vue?vue&type=script&lang=js&"
export * from "./SingleJobView.vue?vue&type=script&lang=js&"
import style0 from "./SingleJobView.vue?vue&type=style&index=0&id=54f3ba1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3ba1c",
  null
  
)

export default component.exports